module.exports = __webpack_public_path__ + "img/nsima-team.8b75583d.svg";